<template>
  <div class="order-support">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'order-support',
};
</script>

<style lang="scss">
.order-support {
  margin-top: 22px;
  padding: 12px;
  font-size: 14px;
  line-height: 20px;
  color: $gray;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .04), 0 8px 24px rgba(0, 0, 0, .03), 0 16px 32px rgba(0, 0, 0, .02);

  & > a {
    display: inline-block;
    color: $black;
  }
}

@include breakpoint("desktop") {
  .order-support {
    margin-top: 56px;
    padding: 20px;
    font-size: 16px;
    line-height: 24px;
  }
}
</style>